import React from 'react';
import { View } from '@24i/nxg-sdk-quarks';
import { WrapperProps } from './types';

const Wrapper = ({ children = null, styles = {} }: WrapperProps) => (
    <View style={styles.screenContainer}>{children}</View>
);

export default Wrapper;
